import { render, staticRenderFns } from "./Quotation-Setting.vue?vue&type=template&id=45c751ba&"
import script from "./Quotation-Setting.vue?vue&type=script&lang=js&"
export * from "./Quotation-Setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports